import {apiBase} from 'api/base.js';

class EartagDysstasiaImportAPI {
  execute() {
    return apiBase.post('/admin/eartag_dysstasia_import', {});
  }
}

export const eartagDysstasiaImportAPI = new EartagDysstasiaImportAPI();
